// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2I4Xd","file":"styles_file__2dSDc"};